<template>
  <div id="app">
    <router-link to="/Guan"></router-link>
    <router-link to="/Service"></router-link>
    <router-link to="/Case"></router-link>
    <router-link to="/We"></router-link>
    <keep-alive>
    <router-view/>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  html body { padding: 0; margin: 0; }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue